<template>
  <div>
    <h3>Contact Us</h3>

    <p>Tel: 028-8560330</p>
    <p>Post Code: 614000</p>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/about/component/contactUs.vue